// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as UseApi$Showside from "../hook/UseApi.bs.js";
import ReactMetaTags from "react-meta-tags";
import * as Product$Showside from "../types/Product.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as Location$Showside from "./Location.bs.js";
import * as LocationConfig$Showside from "./LocationConfig.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
var MetaTags = {};
function MetaTags$1(Props) {
  var match = ConfigurationProvider$Showside.use(undefined);
  var config = match.config;
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var route = match$1.route;
  var match$2 = LocationConfig$Showside.use(undefined);
  var activeCategory = RouterProvider$Showside.useActiveCategory(undefined, undefined, config.categories);
  var match$3 = EntrypointContext$Showside.use(undefined);
  var productId;
  if (typeof route === "number") {
    productId = undefined;
  } else {
    switch (route.TAG | 0) {
      case /* PDP */2:
        productId = route._0.productId;
        break;
      case /* QuickView */3:
        productId = route._0.productId;
        break;
      default:
        productId = undefined;
    }
  }
  var match$4 = UseApi$Showside.useProductById(false, Belt_Option.map(activeCategory, function (cat) {
    return cat.id;
  }), match$3.smartnavApiHost, match$3.market, Belt_Option.getWithDefault(productId, ""));
  var product = match$4.product;
  var bio = config.settings.mkrBio;
  if (bio === undefined) {
    return null;
  }
  var name = bio.name;
  var prefix = name !== undefined ? name + "'s " : "";
  var title;
  if (typeof route === "number") {
    title = "Instagram Posts";
  } else {
    switch (route.TAG | 0) {
      case /* Home */0:
        title = "Instagram Posts";
        break;
      case /* ListPage */1:
        if (activeCategory !== undefined && activeCategory.title !== "Instagram") {
          var match$5 = activeCategory.socialNetworkSource;
          title = match$5 !== undefined ? match$5.TAG === /* Instagram */0 ? "Instagram Posts" : "Tiktok Videos" : activeCategory.title;
        } else {
          title = "Instagram Posts";
        }
        break;
      case /* PDP */2:
      case /* QuickView */3:
        title = product !== undefined ? product.name : "Instagram Posts";
        break;
    }
  }
  var title$1 = prefix + title + " in Mkr Bio";
  var image;
  if (typeof route === "number") {
    image = bio.logoUrl;
  } else {
    switch (route.TAG | 0) {
      case /* PDP */2:
        image = product !== undefined ? Belt_Array.get(Product$Showside.getValidProductImages(product), 0) : bio.logoUrl;
        break;
      case /* QuickView */3:
        image = product !== undefined ? Belt_Array.get(Product$Showside.getValidProductImages(product), 0) : Belt_Option.map(Category$Showside.getCategoryById(config.categories, route._0.mediaId), Category$Showside.getCategoryImage);
        break;
      default:
        image = bio.logoUrl;
    }
  }
  var video;
  var exit = 0;
  var product$1;
  if (typeof route === "number") {
    video = undefined;
  } else {
    switch (route.TAG | 0) {
      case /* PDP */2:
        if (product !== undefined) {
          product$1 = product;
          exit = 1;
        } else {
          video = undefined;
        }
        break;
      case /* QuickView */3:
        if (product !== undefined) {
          product$1 = product;
          exit = 1;
        } else {
          video = Belt_Option.flatMap(Category$Showside.getCategoryById(config.categories, route._0.mediaId), Category$Showside.getCategoryVideo);
        }
        break;
      default:
        video = undefined;
    }
  }
  if (exit === 1) {
    video = Belt_Option.flatMap(Belt_Array.get(product$1.allMedia, 0), Product$Showside.Media.getVideoUrl);
  }
  var description;
  if (typeof route === "number") {
    description = bio.description;
  } else {
    switch (route.TAG | 0) {
      case /* PDP */2:
      case /* QuickView */3:
        description = product !== undefined ? product.description : bio.description;
        break;
      default:
        description = bio.description;
    }
  }
  return React.createElement(ReactMetaTags, {
    children: null
  }, React.createElement("title", undefined, title$1), React.createElement("meta", {
    content: title$1,
    property: "og:title"
  }), React.createElement("meta", {
    content: "website",
    property: "og:type"
  }), React.createElement("meta", {
    content: prefix + "Mkr Bio",
    property: "og:site_name"
  }), React.createElement("meta", {
    content: Location$Showside.getCurrentPermalink(match$2.namespace, undefined),
    property: "og:url"
  }), Belt_Option.mapWithDefault(image, null, function (image) {
    return React.createElement("meta", {
      content: image,
      property: "og:image"
    });
  }), Belt_Option.mapWithDefault(video, null, function (video) {
    return React.createElement("meta", {
      content: video,
      property: "og:video"
    });
  }), Belt_Option.mapWithDefault(description, null, function (description) {
    return React.createElement("meta", {
      content: description,
      property: "og:description"
    });
  }));
}
MetaTags$1.displayName = "MetaTags.1";
var make = MetaTags$1;
export { MetaTags, make };
/* react Not a pure module */